import { render, staticRenderFns } from "./bookman-footer.vue?vue&type=template&id=643ba949&"
import script from "./bookman-footer.vue?vue&type=script&lang=js&"
export * from "./bookman-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports